import amex from '../assets/images/cards/amex.png';
import defaultImg from '../assets/images/cards/default.png';
import diners from '../assets/images/cards/diners.png';
import discover from '../assets/images/cards/discover.png';
import jcb from '../assets/images/cards/jcb.png';
import maestro from '../assets/images/cards/maestro.png';
import mastercard from '../assets/images/cards/mastercard.png';
import visa from '../assets/images/cards/visa.png';

export default {
  amex,
  diners,
  discover,
  jcb,
  maestro,
  mastercard,
  visa,
  defaultImg,
};
